import { IframeUserLoginRequest, LoginResponse } from "@/types/authService";
import axiosInstance from "@/utils/axiosInstance";

const iframeAuthService = {
  loginUser: async (loginData:IframeUserLoginRequest) : Promise<LoginResponse> => {
    const response = await axiosInstance.post(
      "/backend-api/auth/user/login",
      loginData
    );
    return response.data;
  },
};

export default iframeAuthService;
